import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigationData: FuseNavigationItem[] = [
    {
        id   : 'home',
        title: 'Inicio',
        type : 'basic',
        icon : 'home',
        link : '/home',
        tooltip:'Inicio'
    },
    {
        id   : 'listado-registros',
        title: 'Listado de Registros',
        type : 'basic',
        icon : 'format_list_bulleted',
        link : '/listado-registros',
        tooltip:'Inicio'
    },
    {
        id   : 'catalogos',
        title: 'Catalogos',
        type : 'basic',
        icon : 'library_books',
        link : '/catalogos',
        tooltip:'Catalogos'
    },
    {
        id   : 'usuarios',
        title: 'Usuarios',
        type : 'collapsable',
        icon : 'groups',
        tooltip: 'Configuración',
        meta: {
            protected: true
        },
        children: [

            /*{   id   : 'agregar-usuario',
                title: 'Agregar Usuario',
                type : 'basic',
                icon : 'person_add',
                link : '/agregar-usuario',
                tooltip: 'Agregar Usuario',
            },*/
            {   id   : 'users',
                title: 'Gestionar Usuarios',
                type : 'basic',
                icon : 'group',
                link : '/listado-usuarios',
                tooltip: 'Gestion de Usuarios',
            },
        ]
    },
    {
        id   : 'logout',
        title: 'Cerrar sesión',
        type : 'basic',
        icon : 'logout',
        link : '/sign-out',
        tooltip: 'Cerrar sesión'
    },
];
